import { BFormInput } from "bootstrap-vue";
import { ConnexionPageState } from "../ConnexionPageState";
import { ConnexionPageInitial } from "./ConnexionPageInitial";
import Dictionary from "@/types/Dictionary";
import { API_URL } from "@/App.settings";
import { ConnexionPageWeakPassword } from "./ConnexionPageWeakPassword";
import Vue from "vue";
import axios from "axios";
import { ConnexionPageResetPassword } from "./ConnexionPageResetPassword";

/** Etat de gestion d'un oublie de mot de passe */
export class ConnexionPageAuthBasic extends ConnexionPageState{
    
    /** Lance la procédure de connexion avec le mot de passe saisi */
    public async SignIn(): Promise<void> {
        /** Overlay de chargement DCX */
        this.context.Vue.$store.dispatch("ShowLoadingMask", this.context.Vue.$t('LoginInProgress'));     // "Identification en cours"

        this.context.PasswordLocked = false;
        
        const args: Dictionary<any> = {
            Login: this.context.AuthLogin,
            Password: this.context.Password
        };

        try{
            /** S'authentifie auprès du serveur */
            const response = await axios.post(API_URL + "Connexion/Ident", args);
            if (response && response.data) {

                /** Ajoute dans les cookies l'identifiant de la session */
                this.context.Vue.$cookies.set('access_token', response.data.access_token);
                this.context.Vue.$cookies.set('access_token_timestamp', Date.now());

                this.context.Vue.$store.dispatch("SessionStore/SetIsSupervisor", response.data.isSupervisor);

                if(response.data.connections) {
                    /** Utilisateur lié à une base cliente */ 
                    if(!response.data.IsPasswordSecure && process.env.VUE_APP_NAME != 'Development'){
                        /** Mot de passe peut sécurisé */
                        this.context.SignInResult = {
                            IsPasswordSecure: response.data.IsPasswordSecure,
                            Ik: response.data.iK,
                            HasConnection: true
                        }
                        this.context.ShowWeakPasswordPolicy = true;
                        this.context.State = new ConnexionPageWeakPassword(this.context);
                    }else{
                        /** Traitement et redirection vers Master en cas d'une connexion cliente */
                        this.context.Vue.GoMaster(response.data.iK)
                    }
                }
                else {   
                    /** Utilisateur non lié à une base cliente */ 
                    if(!response.data.IsPasswordSecure && process.env.VUE_APP_NAME != 'Development'){
                        this.context.SignInResult = {
                            IsPasswordSecure: response.data.IsPasswordSecure,
                            Ik: response.data.iK,
                            HasConnection: false
                        }
                        this.context.ShowWeakPasswordPolicy = true;
                        this.context.State = new ConnexionPageWeakPassword(this.context);
                    }else
                        this.context.ShowBddList = true;
                }
                this.context.ShowPasswordForm = true;
            }
            else 
                this.showToast("warning", this.context.Vue.$t('UnableToConnect').toString(), this.context.Vue.$t('PleaseRetry').toString())
        }catch(err){
            /** ECHEC */
            console.error(err);
            this.showToast("danger", this.context.Vue.$t('Error').toString(), this.context.Vue.$t('AnErrorOccured').toString())
        }finally{
            /** CLEANUP */
            this.context.Vue.$store.dispatch("HideLoadingMask", {});
        }

        /** Attend le rafraichissement du DOM pour demander le focus */
        await Vue.nextTick();
        /** Prend le focus */
        const inputLogin = this.context.Vue.$refs.loginRef as BFormInput;
        let inputEl: HTMLInputElement = inputLogin.$el as HTMLInputElement;
        for(let i: number = 0; i < 5 ; i++)
        {
            if(inputEl)
            {
                (inputLogin.$el as HTMLInputElement).focus();
                break;
            }
            /** Si le temps prend plus de temps que prévu pour se générer on patiente le tick suivant 5 fois max, sinon on abandonne le focus */
            await Vue.nextTick();
            inputEl = inputLogin.$el as HTMLInputElement;
        }
    }

    /** Annule l'authentification et retourne sur la page saisie du login */
    public async Abord(): Promise<void> {
        this.context.ShowPasswordForm = false;
        this.context.ShowLoginForm = true;
        this.context.Login = this.context.AuthLogin;
        this.context.AuthLogin = "";
        this.context.PasswordLocked = false;

        /** Attend le "render" du "DOM" avant de demander le focus */
        await Vue.nextTick();
        /** Prend le focus sur le champ de saisie "login" */
        const inputPassword = this.context.Vue.$refs.loginRef as BFormInput;
        (inputPassword.$el as HTMLInputElement).focus();

        this.context.State = new ConnexionPageInitial(this.context);
    }

    /** Racourci pour simplifier l'utilisation du toaster */
    private showToast(variant: string, title: string, message: string){
        /** La réponse est invalid -> Nous devons afficher une érreur ou un avertissement */
        this.context.LoginFailed = true;
        this.context.ShowLoginForm = true;
        this.context.ShowPasswordForm = false;
        this.context.Password = "";

        this.context.State = new ConnexionPageInitial(this.context);

        this.context.Vue.$bvToast.toast(message, {     // Veuillez saisir de nouveau votre identifiant et votre mot de passe ou contacter votre administrateur. Vos droits sont peut-être échus.
            title: title,           
            autoHideDelay: 10000,
            variant: variant,
            solid: true,
            appendToast: true,
            toaster: "b-toaster-top-center"
        });
    }
    
    /** Affiche le formulaire de saisie du login pour initier un reset du mot de passe */
    public ResetPassword(): void { 
        /** Pré-rempli le champ avec la saisie en cours du login */
        if(this.context.Login)
            this.context.LoginForgotPassword = this.context.Login;

        /** Masque le formulaire de saisie du login */
        this.context.ShowPasswordForm = false;
        /** Affiche le formulaire */
        this.context.ShowResetPasswordForm = true;
        /** Change le comportement de la vue */
        this.context.State = new ConnexionPageResetPassword(this.context);
    }

    //#region CAS INGORE
    
    /** VOID */
    public async SendMail(): Promise<void> { /** Non proposé à l'utilisateur */ }

    /** VOID */
    public About(): void { /** Non proposé à l'utilisateur */ }
    //#endregion CAS INGORE
}